<div class="header">
  <div class="header-logo">
    <div class="side-logo">
      <img src="../../../assets/website-assets/images/baba_balak_nath_logo.png" alt="BBN Temple Logo" routerLink="/home-page" >
    </div>
    <div class="main-logo">
      <img src="../../../assets/images/full-logo1.png" alt="BBN Temple Logo">
    </div>
  </div>
  <div class="text-center">
    <h3>ONLINE SERVICES</h3>
  </div>
</div>

<div class="login-content">
  <div class="row">
    <div class="col-md-8 image-slider">
      <!-- <div id="myCarousel" class="carousel slide" data-bs-ride="carousel">
       
        <div class="carousel-inner">
          <div class="carousel-item active">
           <img class="page-image pd-3" src="../../../assets/website-assets/images/banner_img4.jpg">
            
          </div>
          <div class="carousel-item">
            <img class="page-image pd-3" src="/assets/website-assets/images/banner_img1.jpg">
           
          </div>
          <div class="carousel-item">
            <img class="page-image pd-3" src="/assets/website-assets/images/banner_img2.jpg">
            
          </div> 
        </div>
        
        <a class="carousel-control-prev" href="#myCarousel" role="button" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden"></span>
        </a>
        <a class="carousel-control-next" href="#myCarousel" role="button" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden"></span>
        </a>
      </div> -->

    
      
      

      <div id="imageCarousel" class="carousel slide" data-ride="carousel">
        <!-- Carousel Indicators -->
        <!-- <ol class="carousel-indicators">
            <li *ngFor="let item of arr_banner; let i = index" data-target="#imageCarousel"
                [attr.data-slide-to]="i" [class.active]="i === 0">
            </li>
        </ol> -->

        
        <!-- Carousel Slides -->
        <div class="carousel-inner">
            <div *ngFor="let item of arr_banner; let i = index"
                class="carousel-item" [class.active]="i === 0">
                <img class="page-image pd-3" [src]="item.FilePath" >
            </div>
        </div>
        
        


        <a class="carousel-control-prev" href="#imageCarousel" role="button" data-slide="prev">
            <i class="carousel-control-prev-icon" aria-hidden="true"></i> <!-- Font Awesome icon for previous -->
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#imageCarousel" role="button" data-slide="next">
            <i class="carousel-control-next-icon" aria-hidden="true"></i> <!-- Font Awesome icon for next -->
            <span class="sr-only">Next</span>
          </a>
    </div>
      
      <!-- <img class="page-image pd-3" src="../../../assets/website-assets/images/banner_img4.jpg"> -->
    </div>



    <div class="col-md-4 pd-3" style="padding-right: 28px;">
      <div class="card login-card">
        <div class="card-body">
          <h4 class="text-center">Login</h4>
          <form class="pt-3" [formGroup]="otpform" *ngIf="LoginBy == 0">
            <div class="form-group" *ngIf="!showOTP">
              <input type="email" formControlName="email" autocomplete="off" [class.is-invalid]="this.otpform.get('email').touched
                && this.otpform.get('email').invalid" class="form-control form-control-lg" id="email"
                placeholder="Email Address">
              <span class="mandatory-span" *ngIf="this.otpform.get('email').touched
                && this.otpform.get('email').value == ''">Email is required</span>
              <span class="mandatory-span" *ngIf="this.otpform.get('email').touched
                && this.otpform.get('email').value != '' &&
                this.otpform.get('email').invalid">Invalid format</span>
            </div>
            <div class="form-group" *ngIf="!showOTP">
              <input type="text" formControlName="mobno" autocomplete="off" minlength="10" maxlength="10"
                onkeypress="return isNumberKey(event)" [class.is-invalid]="this.otpform.get('mobno').touched
                && this.otpform.get('mobno').invalid" class="form-control form-control-lg" id="mobno"
                placeholder="Mobile Number">
              <span class="mandatory-span" *ngIf="this.otpform.get('mobno').touched
                && this.otpform.get('mobno').value == ''">Mobile Number is required</span>
              <span class="mandatory-span" *ngIf="this.otpform.get('mobno').touched
                && this.otpform.get('mobno').value != '' &&
                this.otpform.get('mobno').invalid">Invalid format</span>
            </div>
            <span class="note-text" *ngIf="!showOTP">OTP will be sent to your Email Address.</span>
            <div class="form-group" *ngIf="showOTP">
              <p>OTP will be sent to your Email Address.</p>
              <input type="text" formControlName="OTP" autocomplete="off" onkeypress="return isNumberKey(event)"
                [class.is-invalid]="this.otpform.get('OTP').touched
                && this.otpform.get('OTP').invalid" class="form-control form-control-lg" id="otp" minlength="4"
                maxlength="4" placeholder="Enter OTP">
              <span class="mandatory-span" *ngIf="this.otpform.get('OTP').touched &&
                this.otpform.get('OTP').value == ''">OTP is
                required</span>
              <span class="mandatory-span" *ngIf="this.otpform.get('OTP').touched &&
                this.otpform.get('OTP').value != '' &&
                this.otpform.get('OTP').invalid">Invalid Format</span>
            </div>
            <div *ngIf="showOTP" style="display:inline-flex;width:100%;">
              <a *ngIf="!remainingTime" (click)="GetOTP()" style="width:100%;text-align: left;">Resend OTP</a>
              <p *ngIf="remainingTime" style="width:100%;text-align: right;">Resend OTP in 0{{ minutes }} : {{ seconds
                }}</p>
            </div>
            <div class="mt-3" *ngIf="!showOTP">
              <button (click)="GetOTP()"
                [disabled]="this.otpform.get('email').invalid || this.otpform.get('mobno').invalid"
                class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn save-button">Get OTP</button>
            </div>
            <div class="mt-3" *ngIf="showOTP">
              <button (click)="ValidateOTP()" [disabled]="this.otpform.get('OTP').invalid" class="bbtn btn-block btn-primary btn-lg font-weight-medium
              auth-form-btn save-button">Validate OTP</button>
            </div>
          </form>

          <form class="pt-3" [formGroup]="passwordform" *ngIf="LoginBy == 1">
            <div class="form-group">
              <input type="email" formControlName="email" autocomplete="off" [class.is-invalid]="this.passwordform.get('email').touched
                && this.passwordform.get('email').invalid" class="form-control form-control-lg" id="email"
                placeholder="Email Address">
              <span class="mandatory-span" *ngIf="this.passwordform.get('email').touched
                && this.passwordform.get('email').value == ''">Email Address is required</span>
              <span class="mandatory-span" *ngIf="this.passwordform.get('email').touched
                && this.passwordform.get('email').value != '' &&
                this.passwordform.get('email').invalid">Invalid format</span>
            </div>
            <div class="form-group">
              <input type="text" formControlName="mobno" autocomplete="off" minlength="10" maxlength="10"
                onkeypress="return isNumberKey(event)" [class.is-invalid]="this.passwordform.get('mobno').touched
                && this.passwordform.get('mobno').invalid" class="form-control form-control-lg" id="mobno"
                placeholder="Mobile Number">
              <span class="mandatory-span" *ngIf="this.passwordform.get('mobno').touched
                && this.passwordform.get('mobno').value == ''">Mobile Number is required</span>
              <span class="mandatory-span" *ngIf="this.passwordform.get('mobno').touched
                && this.passwordform.get('mobno').value != '' &&
                this.passwordform.get('mobno').invalid">Invalid format</span>
            </div>
            <div class="form-group">
              <input [type]="show?'text':'password'" formControlName="password" class="form-control form-control-lg"
                [class.is-invalid]="this.passwordform.get('password').touched && this.passwordform.get('password').invalid"
                id="exampleInputPassword1" placeholder="Password">
              <button (click)="toggleIcon()" class="login-eye-button">
                <i [class]="show?'fa fa-eye-slash':'fa fa-eye'" aria-hidden="true"></i>
              </button>
              <span class="mandatory-span"
                *ngIf="this.passwordform.get('password').touched && this.passwordform.get('password').invalid">Password
                is
                required</span>
            </div>
            <div class="form-group">
              <ngx-recaptcha2 #captchaElem [siteKey]="sitekey" class="recaptchass" (reset)="reset()"
                (expire)="handleExpire()" (load)="handleLoad()" (success)="handleSuccess($event)"
                [useGlobalDomain]="false" [size]="size" [hl]="lang" [theme]="theme" [type]="type"
                formControlName="recaptcha">
              </ngx-recaptcha2>
            </div>
            <div class="mt-3">
              <button (click)="Login()"
                [disabled]="this.passwordform.get('email').invalid || this.passwordform.get('mobno').invalid || this.passwordform.get('password').invalid"
                class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn save-button">SIGN IN</button>
            </div>
            <!-- <div class="my-2 d-flex justify-content-between align-items-center" style="width:100%;">

              <a [routerLink]="['/forgotpassword']" class="auth/forgotpassword text-black forgot-button"
                style="text-align:right;width:100%;">Forgot Password?</a>
            </div> -->
          </form>
          <div class="or-bx">
            <div class="line"><span>OR</span></div>
          </div>

          <button (click)="toggleForm();" class="custom-button-style">{{LoginBy == 0?'Login With Password':'Login With OTP'}}</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="row update-section">
  <div class="updates col-sm-3 spacing">
    <div class="contHead">Recent Updates</div>
    <div>
      <ul class="bullet">
        <!-- <span>
          <li style="margin-top: 10px !important">Advance Booking
            for all Services for the month of February'2024 is released.</li>
        </span> -->
        <span>
          <li style="margin-top: 10px !important" *ngFor="let item of arr_notifications" routerLink="/home-page/notification" title="Click to view" style="cursor: pointer;">{{item.Title}}
          </li>
        </span>
        <!-- <span>
          <li style="margin-top: 10px !important">Shrine board has
            introduced “Group Attka Aarti” Scheme under which a maximum of 04 Pilgrims can avail Attka Aarti along
            with Complimentary Accommodation in Dormitory at Bhawan.</li>
        </span> -->
      </ul>
      <!-- <div class="col-md-12">
        <img height="90%" width="90%" src="/assets/website-assets/images/qr.png" alt="QR Code For Payment">
      </div> -->
    </div>
  </div>
  <div class="col-sm-8 info-section">
    <div class="heading-text"> Important Information : must read before Online Booking.</div>
    <div class="info-text">
      <ul>
        <span>
          <li>
            <div> Advance Booking for all Services for the month of February'2024 is now released. </div>
          </li>
        </span>
        <span>
          <li>
            <div> Devotees can avail Online Services with valid Mobile number. Please complete the registration process
              for Temple Board to provide Services. </div>
          </li>
        </span>
        <span>
          <li>
            <div> "For forgot Password / Account Lock / OTP Issues " please click Forgot
              Password and give your registered Mobile Number to receive OTP. Please check email in
              Spam/Junk/Bin/Trash folders as well. </div>
          </li>
        </span>
        <span>
          <li>
            <div> Beware...! Never share Debit/Credit/Account details, ATM PIN, Passwords, CVV,
              OTP over phone/email. Temple Board never asks for such details. </div>
          </li>
        </span>
        <span>
          <li>
            <div> Temple Board has not authorized any agent/s for Online Booking of Darshan /
              Accommodation and other Services. </div>
          </li>
        </span>
        <span>
          <li>
            <div> For Any issues related to availing Online Services please write to us at
              , alternately Pilgrims can reach out to us at the following helpline numbers
              . </div>
          </li>
        </span>
        <span>
          <li>
            <div> For any concerns regarding Login/online services, NRI devotees can contact us
              at  to receive quick assistance and responses to their inquiries. </div>
          </li>
        </span>
      </ul>
    </div>
  </div>
</div>

<div class="footer-section">
  <span class="footer-text">Copyright © {{CurrentYear}} Jai Baba Balak
    Nath</span>
</div>